const ALERT_DELAY = 5000;
const $ = window.$;

function autoHideAlert() {
  setTimeout(() => {
    $('#nex-alert').alert('close');
  }, ALERT_DELAY);
}

/*
document.body.innerHTML += `<div id="nex-alert" class="alert alert-success alert-dismissible fade show" role="alert">
	${message}
	<button type="button" class="close" data-dismiss="alert" aria-label="Close">
		<span aria-hidden="true">&times;</span>
	</button>
</div>`;
*/

function createAlert(message, klass) {
  const divAlert = document.createElement('div');

  divAlert.className = `alert alert-${klass} alert-dismissible fade show`;
  divAlert.setAttribute('role', 'alert');
  divAlert.setAttribute('id', 'nex-alert');
  divAlert.innerHTML = `${message}
		<button type="button" class="close" data-dismiss="alert" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>`;

  return divAlert;
}

export function showAlert(message, klass = 'primary', autoClose = true) {
  const divAlert = createAlert(message, klass);
  let sectionAlert = document.getElementById('section-alert');
  if (!sectionAlert) {
    const divSectionAlert = document.createElement('div');
    divSectionAlert.id = 'section-alert';
    document.body.append(divSectionAlert);

    sectionAlert = document.getElementById('section-alert');
  }

  sectionAlert.appendChild(divAlert);

  $('#nex-alert').alert();
  if (autoClose) autoHideAlert();
}
